const editformdatadialog = [{
		inputdata: '',
		title: '出库单号',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '180px',
		lablewith: '80px',
		btx: true
	},
	{
		inputdata: '',
		title: '出库日期',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: '',
		inputtype: 'datess',
		width: '180px',
		lablewith: '120px',
		btx: true
	},
	{
		inputdata: '',
		title: '产品线',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '190px',
		btx: true,
		lablewith: '120px',
		options: [],
		event: "invClass"
	},
	{
		inputdata: '',
		title: '单据类型',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'select',
		width: '190px',
		btx: true,
		lablewith: '80px',
		options: [{
				key: "1",
				value: "平台",
			},
			{
				key: "2",
				value: "经销商",
			}
		],
		event: "voucherTypeChange"
	},
	{
		inputdata: '',
		title: '付款方',
		fontSize: '14px',
		color: '#333333',
		placeholder: '全部',
		types: '',
		inputtype: 'selectautocompletes',
		width: '215px',
		btx: true,
		lablewith: '120px',
		options: [],
		event: "HosTypeChage"
	},
	{
		inputdata: '',
		title: '备注',
		fontSize: '14px',
		color: '#333333',
		placeholder: '请输入',
		types: 'text',
		inputtype: 'input',
		width: '180px',
		lablewith: '95px',
	},
	{
		inputdata: "",
		title: "终端医院",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompleteHosType",
		width: "190px",
		btx: true,
		lablewith: "80px",
		options: [],
		selcoms: false,
		event: "terminalHospitalChange"
	},
	{
		inputdata: "",
		title: "是否新模式",
		fontSize: "14px",
		color: "#333333",
		placeholder: "",
		types: "",
		inputtype: "checkboxs",
		checkboxdata: [{
			label: "1",
			value: "",
		}],
		width: "",
		lablewith: "85px",
		checkFlag: false
	}, {
		inputdata: "",
		title: "手术日期",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "datess",
		width: "180px",
		lablewith: "80px",
		dateFlag: false,
	}, {
		inputdata: "",
		title: "手术类型",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "80px",
		inputflag: false,
	}, {
		inputdata: "",
		title: "科室",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请选择",
		types: "",
		inputtype: "select",
		width: "180px",
		lablewith: "80px",
		options: [],
		selcoms: false,
		inputflag: false,
	}, {
		inputdata: "",
		title: "医生",
		fontSize: "14px",
		color: "#333333",
		placeholder: "请输入",
		types: "text",
		inputtype: "input",
		width: "180px",
		lablewith: "80px",
		inputflag: false,
	},
	{
		inputdata: "",
		title: "寄售库",
		fontSize: "14px",
		color: "#333333",
		placeholder: "全部",
		types: "",
		inputtype: "selectautocompletes",
		width: "190px",
		btx: true,
		lablewith: "75px",
		options: [],
		event: "HosTypeJsChage",
		selcoms: false,
	}
]
export default editformdatadialog;